import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, GoogleLogo, EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { SITE, NAV } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-sa-ink text-sa-bg mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-sa-bg text-sa-ink flex items-center justify-center font-serif text-xl">S</div>
            <div className="font-serif text-2xl">Shady Acres Caravan Park</div>
          </div>
          <p className="mt-6 text-sa-bg/70 text-[15px] leading-relaxed max-w-md">
            A quiet, family-run park in Warrenheip on twelve acres of native gums — directly on the M8 at the eastern edge of Ballarat, a 90-minute drive from Melbourne.
          </p>
          <div className="flex items-center gap-4 mt-8">
            <a aria-label="Instagram" href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-sa-bg/20 grid place-items-center hover:bg-sa-bg/10" data-testid="footer-instagram">
              <InstagramLogo size={18} weight="duotone" />
            </a>
            <a aria-label="Facebook" href="https://www.facebook.com/profile.php?id=100064074489727" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-sa-bg/20 grid place-items-center hover:bg-sa-bg/10" data-testid="footer-facebook">
              <FacebookLogo size={18} weight="duotone" />
            </a>
            <a aria-label="Google reviews" href="https://www.google.com.ng/travel/hotels/entity/ChcIl6yjvefp_NQJGgsvZy8xdGpjcGwwYhAB/reviews?utm_campaign=sharing&utm_medium=link&utm_source=htls&ts=CAEaIAoCGgASGhIUCgcI6g8QBhgdEgcI6g8QBhgeGAEyAhAAKgQKABoA" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-sa-bg/20 grid place-items-center hover:bg-sa-bg/10" data-testid="footer-google">
              <GoogleLogo size={18} weight="duotone" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-sa-accent">Explore</div>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sa-bg/80 hover:text-sa-bg" data-testid={`footer-nav-${n.label.toLowerCase()}`}>
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/policies" className="text-sa-bg/80 hover:text-sa-bg" data-testid="footer-policies">Policies</Link>
            </li>
            <li>
              <Link to="/policies#terms" className="text-sa-bg/80 hover:text-sa-bg" data-testid="footer-terms">Terms &amp; Conditions</Link>
            </li>
            <li>
              <Link to="/policies#privacy" className="text-sa-bg/80 hover:text-sa-bg" data-testid="footer-privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/book" className="text-sa-accent hover:text-white" data-testid="footer-book">Book a stay →</Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-sa-accent">Visit / Contact</div>
          <ul className="mt-5 space-y-4 text-sa-bg/80 text-[15px]">
            <li className="flex items-start gap-3"><MapPin size={18} weight="duotone" className="mt-1 text-sa-accent" /> {SITE.address}</li>
            <li className="flex items-center gap-3"><Phone size={18} weight="duotone" className="text-sa-accent" /> <a href={`tel:${SITE.phone_intl}`} className="hover:text-sa-bg">{SITE.phone}</a></li>
            <li className="flex items-center gap-3"><EnvelopeSimple size={18} weight="duotone" className="text-sa-accent" /> <a href={`mailto:${SITE.email}`} className="hover:text-sa-bg">{SITE.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-sa-bg/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-sa-bg/50">
          <div>© {new Date().getFullYear()} Shady Acres Caravan Park · Ballarat VIC</div>
          <div className="flex items-center gap-4">
            <Link
              to="/sitemap"
              className="hover:text-sa-bg/90"
              data-testid="footer-sitemap"
            >
              Sitemap
            </Link>
            <span className="hidden md:inline">Some imagery is illustrative and not taken on site.</span>
          </div>
          <div className="md:hidden">Some imagery is illustrative and not taken on site.</div>
        </div>
      </div>
    </footer>
  );
}
